import { ModuleWithProviders, NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { AutoCompleteCmp } from './auto-complete';
import { BaiduPlacesProvider } from './baidu-places.provider';
import { AutoCompleteModalCmp } from './auto-complete-modal';

export { BaiduPlacesProvider } from './baidu-places.provider';


export class AutoCompleteModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: AutoCompleteModule,
      providers: [
        BaiduPlacesProvider
      ]
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    IonicModule
  ],
  exports: [
    AutoCompleteCmp,
    AutoCompleteModalCmp
  ],
  declarations: [
    AutoCompleteCmp,
    AutoCompleteModalCmp
  ],
  entryComponents: [
    AutoCompleteModalCmp
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
